import { AppRemoteConfigAndValuesMap } from "../../central-atoms/org-app-map/types"
import { UpdateRemoteConfigDispatchedAction } from "../types/actions"
import { UPDATE_REMOTE_CONFIG_VALUES } from "./actionTypes"

export const updateRemoteConfigValues = (values: AppRemoteConfigAndValuesMap): UpdateRemoteConfigDispatchedAction => {
    return {
        type: UPDATE_REMOTE_CONFIG_VALUES,
        payload: {
            values,
        }
    }
}